import React from 'react';

import { DentiraIcon } from './Styles/Icons';
import { Button, RootContainer, FlexRow, ErrorImage } from './Styles/ErrorBoundary';

import { history } from '../../commons/utils';

export default class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			hasError: false,
		};
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {}

	handleHomeRedirect = () => {
		history.push('/');
		this.setState({
			hasError: false,
		});
	};

	render() {
		if (this.state.hasError) {
			return (
				<RootContainer style={{ gap: '1rem', marginTop: '5%' }}>
					<FlexRow style={{ justifyContent: 'center' }}>
						<ErrorImage
							src={DentiraIcon}
							onClick={this.handleHomeRedirect}
						/>
					</FlexRow>

					<FlexRow style={{ justifyContent: 'center' }}>Oops! Something Went Wrong.</FlexRow>

					<FlexRow style={{ justifyContent: 'center' }}>
						<Button
							primary
							onClick={(e) => {
								this.handleHomeRedirect();
							}}
						>
							Home
						</Button>
					</FlexRow>
				</RootContainer>
			);
		}

		return this.props.children;
	}
}
